
<template>
  <div>
    <date-filter :namespace="namespace"></date-filter>
    <b-row class="mt-3">
      <b-col lg="6">
        <worker-filter :namespace="namespace"></worker-filter>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <group-by-date-filter :namespace="namespace"></group-by-date-filter>
      </b-col>
    </b-row>
    <b-spinner v-if="loading" class="mb-2 ml-3"></b-spinner>
    <MotivateCookerTableStats :loading="loading" :namespace="namespace"></MotivateCookerTableStats>
  </div>
</template>

<script>
import DateFilter from './DateFilter'
import WorkerFilter from './WorkerFilter'
import GroupByDateFilter from './GroupByDateFilter'
import MotivateCookerTableStats from './MotivateCookerTableStats'
export default {
  name: 'MotivateCookStats',
  components: {
    MotivateCookerTableStats,
    DateFilter,
    WorkerFilter,
    GroupByDateFilter
  },
  data () {
    return {
      namespace: 'admin/cookerMotivate'
    }
  },
  computed: {
    loading () {
      return this.$store.state.admin.cookerMotivate.loadingQuery
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MotivateCookStats.vue